module.exports = __webpack_public_path__ + "static/img/g6.c37f1d6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/padImg/g6.png
// module id = kkvX
// module chunks = 1